 $(document).ready(function() {
        $('.cstm-collapsible-btn').on('click', function() {
            $(this).parent('.cstm-colllapsible-row').toggleClass('cstm-colllapsible-row-ac');

            $(this).next('.cstm-collapsible-body').slideToggle();
            $('.cstm-collapsible-btn').not(this).next('.cstm-collapsible-body').slideUp();
            $('.cstm-colllapsible-row').not($(this).parent('.cstm-colllapsible-row')).removeClass('cstm-colllapsible-row-ac');
        });
      $('.cstm-colllapsible-row:first-child .cstm-collapsible-body').slideDown();
  $('.cstm-colllapsible-row:first-child').addClass('cstm-colllapsible-row-ac'); 
    });


    